import { defineComponent as _defineComponent } from 'vue'
import { watch } from 'vue'
import { logout } from '../util/auth';
import { DataInstance, InviteLinks, Meetings, Userspaces } from '@busy-human/opt-library';
type Emits = {
    (e: 'closeToast'):void
    (e: 'setSigninFalse'):void
}
type Props = {
    user: DataInstance<Userspaces.Model>,
    time?: number,
    showToast?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'account-toast',
  props: {
    user: null,
    time: null,
    showToast: { type: Boolean }
  },
  emits: ["closeToast", "setSigninFalse"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'closeToast'):void
    (e: 'setSigninFalse'):void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    user: DataInstance<Userspaces.Model>,
    time?: number,
    showToast?: boolean
}




const handleLogout = async()=>{
    await logout();
    emit("closeToast")
    emit('setSigninFalse')
}
// watch(()=>props.showToast, ()=>{
//     if(props.showToast){
//         setTimeout(()=>{
//             emit('closeToast')
//         },props.time)
//     }
// })


const __returned__ = { emit, props, handleLogout, watch, logout, DataInstance, InviteLinks, Meetings, Userspaces }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})